import React from 'react';

type Props = {
	children: React.ReactNode;
};

type State = {
	hasError: boolean;
};

// A Spotlight crash would otherwise unmount the whole header root. No reporting here: React already
// passes the caught error to the root's `onCaughtError` (`helpers/reportReactError.ts`).
export class SpotlightErrorBoundary extends React.Component<Props, State> {
	state: State = { hasError: false };

	static getDerivedStateFromError(): State {
		return { hasError: true };
	}

	render() {
		return this.state.hasError ? null : this.props.children;
	}
}
